// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isChannelContractData = objectOf({
  used: number,
  allotment: number,
  contract_start_date: string,
  contract_end_date: string,
  isMessageCreditsConsumption: boolean,
});

export const isAnalyticsDashboardCreditConsumptionDataResult = objectOf({
  smsMms: maybe(isChannelContractData),
  whatsApp: maybe(isChannelContractData),
});
